module.exports = __webpack_public_path__ + "static/media/undraw_social_strategy_1wuq.8cc1a2a2.svg";